(function ($, Drupal) {
  Drupal.behaviors.webforms = {
    attach: function (context, settings) {

      once('event-detail', '.js-event-detail', context).forEach((element) => {
        const el = $(element);
        let url = "";

        if (['state_sponsored', 'internal'].indexOf(el.data('provider')) > -1) {
          url = '/form/intern-event-registration-neu?';
        } else {
          url = '/form/public-event-registration?';
        }

        if ($('#js-multiple-days').text() === "1") {
          el.find(".js-webform-btn").click(function () {
            let nodeId = el.find('#nodeid').text();
            let title = el.find('#main-heading span, .event-internal__headline').text()
            let provider = el.find('.field-provider').text();
            let kursid = el.find('.field-kursid').text();
            let date = 'Ab ' + el.find('.smart-date--date').first().text();
            let date_beginn = el.find('.date_beginn').first().text();
            let time = '';
            let mult = 'mehrtägiges Seminar';
            let selected = '';

            url = url + 'nodeId=' + nodeId + '&provider=' + provider + '&kursid=' + kursid + '&date_beginn=' + date_beginn + '&title=' + title + '&date=' + date + '&time=' + time + '&mult=' + mult;

            var params = new window.URLSearchParams(window.location.search);
            if (params.get('termin')) {
              url = url + '&selected=' + params.get('termin');
            }


            window.location.href = url;
          });
        } else {
          el.find(".js-webform-btn").click(function () {
            let nodeId = el.find('#nodeid').text();
            let title = el.find('#main-heading span, .event-internal__headline').text();
            let provider = el.find('.field-provider').text();
            let kursid = el.find('.field-kursid').text();
            let alldates = el.find('.smart-date--date').text();
            let date = el.find('.smart-date--date').first().text();
            let date_beginn = el.find('.date_beginn').first().text();
            let time = el.find('.smart-date--time').first().text().toLowerCase() ? el.find('.smart-date--time').first().text().toLowerCase() + ' Uhr' : '';
            let mult = '';
            url = url + 'nodeId=' + nodeId + '&provider=' + provider + '&kursid=' + kursid + '&date_beginn=' + date_beginn + '&alldates=' + alldates + '&title=' + title + '&date=' + date + '&time=' + time + '&mult=' + mult;

            var params = new window.URLSearchParams(window.location.search);
            if (params.get('termin')) {
              url = url + '&selected=' + params.get('termin');
            }

            window.location.href = url;
          });
        }
      });

    }
  }
})(jQuery, Drupal);
